var langChi = {
	navi :{
		home: "首頁",
		listing: "目錄",
		cart: "購物車",
		wishList: "購物清單",
		orders: "訂單",
		about: "關於我們",
		login: "登錄",
		account:"賬號",
		logout:"登出",
		dashboard:"管理"
	},
	register: {
		misMatchPassword: "密碼確認失敗",
		missingValue:"缺失必要資料"
	},
	login: {
		login: "登錄",
		register: "新用戶注冊",
		newRegister: "新用戶注冊",
		email: "電郵",
		password: "密碼",
		confirmPassword:"確認密碼",
		cancel: "取消",
		forgotAccountPassword: "忘記賬號/密碼",
		givenName: "名字",
		surName:"姓氏"
	},
	cart: {
		selectAll: "全選",
		unselectAll: "全不選",
		selectAddress: "選擇地址",
		selectContact:"選擇聯繫資訊",
		submitOrder: "提交訂單",
		terms: "條款細則"
	},
	common: {
		remove:"移除",
		update:"更新",
		create:"添加",
		select: "選擇",
		main:"主要",
		website:"網站",
		shopConfigs:"站點資訊",
		infoType:"資訊類型",
		infoConfigs:"資訊類型設置",
		qaReply:"問題回答",
		shopIntro:"站點簡介",
		shops:"站點列表",
		shopInfo:"站點管理",
		shopState:"站點狀態",
		shopName:"站點名稱",
		shopCode:"站點代號",
		domainName:"域名",
		refresh: "刷新",
		name: "名字",
		pickup: "自取",
		phone: "電話",
		pickupLocation: "自取地址",
		phoneAreaNo: "電話區號",
		city: "城市",
		date: "日期",
		add: "添加",
		success: "成功",
		fail: "失敗",
		pleaseLogin: "請登錄",
		pleaseRetry: "請重試",
		confirm: "確認",
		cancel: "取消",
		share: "分享",
		copyUrl: "複製鏈接",
		extLogin: "其他登錄方式",
		terms: "條款細則",
		noData: "沒有數據",
		removeFilter: "移除搜尋條件",
		keyword: "關鍵字",
		tags: "標簽",
		categories: "分類",
		showAll: "顯示全部",
		search: "搜尋",
		addToCart: "加入購物車",
		addToWishList:"加入購物清單",
		price: "價格",
		quant: "數量",
		edit:"編輯",
		shop:"店鋪",
		seq:"次序",
		content:"內容",
		sorting:"排序",
		update:"更新",
		delete:"刪除",
		back:"返回"
	},
	contact: {
		newAddress: "新地址",
		newContact:"新聯絡資訊",
		addressRemark: "地址備注 (例如：辦公室/家)",
		contactName: "聯係人",
		deliveryAddress: "送貨地址",
		wrongContactValue: "錯誤的聯係人資料",
		wrongAddressValue: "錯誤的地址資料",
		wrongPickupValue: "錯誤的自取地址",
		selectPickupLocation:"請選擇自取地點"
	},
	order: {
		order: "訂單",
		orderNum: "訂單號碼",
		detail: "訂單詳情",
		buyerMsg: "用戶留言",
		shopMsg: "店鋪回覆",
		total: "總共",
		payMethods: "付款方式",
		cashOnDelivery: "貨到付款",
		payByFps: "FPS 付款",
		payByPayMe: "PayMe 付款",
		payByAlipay: "Alipay 付款",
		payByWechatpay: "Wechat Pay 付款",
		payByAtm: "銀行轉賬",
		selectedPayment: "已選付款方式",
		isReady:"已經準備好"
	},
	itemDetail: {
		cart: "購物車",
		continue: "繼續選購",
		select: "選擇",
		description:"詳情",
		specs: "規格",
		tags: "標簽",
		addToCart: "加入購物車",
		price: "價格",
		quant: "數量",
		selectAllProperty:"請選擇物品屬性"
	},
	shopsList:{
		search:"搜尋",
		clear:"清除",
		refresh:"刷新"
	},
	postList:{
		add:"添加物品 +",
		addChild:"添加子物品 + ",
		postFilter:"物品篩選",
		shop:"店鋪",
		showAll:"顯示所有"
	},
	postEditor:{
		posts:"物品列表",
		postbase:"基本",
		image:"圖片",
		imageAndContent:"圖文",
		prices:"價格",
		labels:"屬性",
		others:"其他",
		title:"標題",
		seq:"次序",
		content:"內容",
		public:"公開",
		update:"更新",
		childPosts:"補充",
		cancelEdit:"取消更新",
		tags:"標籤",
		categoryLabels:"屬性",
		loadLinks:"加載連結",
		links:"連結",
		more:"更多",
		video:"視頻",
		selectFile:"選擇文件/圖片",
		dropFile:"拖放文件/圖片",
		updateFail:"更新失敗",
		updateFail_8000:"缺少標題/內容",
		updateFail_8001:"找不到對應物品",
		updateFail_8002:"缺少圖片",
		updateFail_8003:"缺少分類",
		updateFail_8004:"缺少價格",
		updateFail_8005:"沒有標籤",
		updateFail_8006:"標籤不齊",
		updateFail_8007:"沒有屬性",
		updateFail_8008:"屬性不齊",
		updateFail_8009:"屬性內容不正確"
	},
	postPrices:{
		set:"設定",
		price:"售價",
		cost:"成本",
		updatePrices:"更新價格",
		properties:"屬性"
	},
	postProps:{
		edit:"編輯",
		newProp:"新屬性",
		properties:"屬性(例如: 大小/顏色)",
		updateProperties:"更新屬性"
	},
	postLink:{
		linkType:"鏈接類型",
		linkUrl:"鏈接地址",
		linkTitle:"鏈接標題",
		web:"網頁",
		youtubeLink:"Youtube 視頻",
		setImage:"設定圖片"
	},
	category:{
		name:"名稱",
		createUnder:"添加於",
		editingCategory:"編輯對象",
		setState:"設定狀態",
		createNewNode:"添加新節點",
		add:"添加",
		edit:"編輯"
	}
}

export default langChi;